if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        const formOptions = this.querySelector('[data-form-option]');
        if (formOptions) {
          this.formOptions = JSON.parse(formOptions.textContent);
          this.multiChoice = null;
        }

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const sellingPlan = this.form.querySelector('[name="selling_plan"]')?.value;

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (sellingPlan) {
          formData.set('selling_plan', sellingPlan);
        }

        config.body = formData;

        if (this.formOptions?.multiple) {
          this.multiChoice = document.querySelector('multi-choice');

          if (this.multiChoice && this.multiChoice?.state?.arrSelectedProduct) {
            const multipleData = this.convertData(this.multiChoice.state.arrSelectedProduct);

            if (sellingPlan && multipleData.items?.length) {
              multipleData.items = multipleData.items.map((item) => ({
                ...item,
                selling_plan: sellingPlan,
              }));
            }

            config.body = JSON.stringify(multipleData);
            config.headers['Content-Type'] = "application/json";
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    try { window.bfTheme?.recalculateAllPrices?.(); } catch (e) {}
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              try { if (window.bfTheme && window.bfTheme.syncDiscountFromCart) window.bfTheme.syncDiscountFromCart(); } catch (e) {}
              try { window.bfTheme?.recalculateAllPrices?.(); } catch (e) {}
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.multiChoice?.resetElement();

            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      convertData(arrSelectedProduct) {
        const filteredData = arrSelectedProduct.filter(i => i !== 0);
        const productsData = filteredData.map(p =>
          ({
            id: p.variants[0].id,
            quantity: 1
          })
        );

        const objProd = this.getMapData(productsData);
        const recalculatedData = Object.keys(objProd).map(key => ({
          id: key,
          quantity: objProd[key]
        }));

        return {
          items: recalculatedData,
          sections: this.cart.getSectionsToRender().map((section) => section.id)
        }
      }

      getMapData(arr) {
        return arr.reduce((acc, cur) => {
          const {id, quantity} = cur;

          if (acc[id] === undefined) {
            acc[id] = quantity
          } else {
            acc[id] += quantity
          }

          return acc;
        }, {});
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
